<span class="carryover-label" *ngIf="isShortForm; else longForm"> CO </span>
<ng-template #longForm>
  <span class="observation-tool-carry-over"> carry-over </span>
</ng-template>
